module.exports = __webpack_public_path__ + "cb66512b49de2bd1e06111fc7caea6c3.pdf";